import { inject, Injectable } from '@angular/core';
import { AmplitudeService } from '@brighthub/logging';
import type { SnapshotStatus } from '../financial-snapshot.model';

/**
 * Amplitude events for Financial Snapshot (PRD §9).
 * PPI: never send dollar amounts — counts / ids / states only.
 */
@Injectable({ providedIn: 'root' })
export class FinancialSnapshotAnalytics {
  private readonly _amplitude = inject(AmplitudeService);

  viewed(clientId: string, state: SnapshotStatus): void {
    this._amplitude.logEvent('snapshot_viewed', {
      client_id: clientId,
      state,
    });
  }

  editOpened(clientId: string): void {
    this._amplitude.logEvent('snapshot_edit_opened', {
      client_id: clientId,
    });
  }

  saved(clientId: string, fieldsEnteredCount: number): void {
    this._amplitude.logEvent('snapshot_saved', {
      client_id: clientId,
      fields_entered_count: fieldsEnteredCount,
      source: 'fa',
    });
  }

  outdatedShown(clientId: string): void {
    this._amplitude.logEvent('snapshot_outdated_shown', {
      client_id: clientId,
    });
  }

  sentToClient(clientId: string, completeness: 'complete' | 'incomplete'): void {
    this._amplitude.logEvent('snapshot_sent_to_client', {
      client_id: clientId,
      completeness,
    });
  }
}
